import { useTranslation } from 'react-i18next';

import { AvatarProps } from '@mui/material';

import clsx from 'clsx';

import { ReactComponent as DefaultAvatar } from '../../assets/default-avatar.svg';
import { DEFAULT_AVATAR_ID } from '../../constants';
import { i18nNS } from '../../i18n';
import { Avatar, avatarClasses } from './styles';
import useCourseUserAvatar, { UseCourseUserAvatar } from './vm';

export type Props = UseCourseUserAvatar & DistributiveOmit<AvatarProps, 'src'>;

const CourseUserAvatar = ({ className, variant = 'rounded', ...props }: Props) => {
  const { t } = useTranslation([i18nNS.COMMON]);

  const { avatarId } = props;
  const { loaded, avatarUrl, nameInitials, handleLoad, session } = useCourseUserAvatar(props);

  return (
    <Avatar
      {...props}
      variant={variant}
      src={!avatarId || avatarUrl === DEFAULT_AVATAR_ID ? undefined : avatarUrl}
      slotProps={{
        img: {
          ...props.slotProps?.img,
          onLoad: handleLoad,
          alt:
            session?.avatar === avatarId
              ? t('your_profile_picture', { ns: i18nNS.COMMON })
              : t('profile_picture', { ns: i18nNS.COMMON }),
        },
      }}
      className={clsx(className, { [avatarClasses.defaultBackground]: !loaded && avatarId })}
    >
      {nameInitials || <DefaultAvatar />}
    </Avatar>
  );
};

export default CourseUserAvatar;
